import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleCheckbox } from '@/components/common/SimpleCheckbox/SimpleCheckbox';
import styles from '../ProductDetailsEdit.module.scss';

interface ExplicitLyricsCheckboxGroupProps {
  value: 'Explicit' | 'Clean' | null | undefined;
  onChange: (value: 'Explicit' | 'Clean' | null) => void;
  disabled?: boolean;
}

export default function ExplicitLyricsCheckboxFormGroup({
  value,
  onChange,
  disabled,
}: ExplicitLyricsCheckboxGroupProps) {
  const { t } = useTranslation();

  const handleExplicitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked ? 'Explicit' : null);
  };

  const handleCleanChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked ? 'Clean' : null);
  };

  return (
    <div className={styles.explicitLyrics}>
      <SimpleCheckbox
        checked={value === 'Explicit'}
        onChange={handleExplicitChange}
        disabled={disabled}
        customLabel={true}
      >
        <span className={styles.explicitBadgeBox}>
          <span className={styles.badge}>
            {t('product.editProduct.explicit')}
          </span>
        </span>
      </SimpleCheckbox>

      <SimpleCheckbox
        checked={value === 'Clean'}
        onChange={handleCleanChange}
        disabled={disabled}
        customLabel={true}
      >
        <span className={styles.cleanBadgeBox}>
          <span className={styles.badge}>{t('product.editProduct.clean')}</span>
        </span>
      </SimpleCheckbox>
    </div>
  );
}
